import { render, staticRenderFns } from "./EmpresaForm.vue?vue&type=template&id=5b4f35d8&scoped=true"
import script from "./EmpresaForm.vue?vue&type=script&lang=js"
export * from "./EmpresaForm.vue?vue&type=script&lang=js"
import style0 from "./EmpresaForm.vue?vue&type=style&index=0&id=5b4f35d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4f35d8",
  null
  
)

export default component.exports